import React from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import './Resume.css'

function Resume_Education() {
  const isSmallScreen = window.innerWidth <= 300;

  return (
    <>
      <Card className={"resume-card"}>
        <h1 className={"resume-card-title"}>Educations</h1> <br></br>
        <Row>
          {/* 첫 번째 열 (연도) */}
          <Col xs={isSmallScreen ? 4 : 2} className="text-center res-year">

            <Row>
              <p> 2023.02 </p>
            </Row>

            <Row>
              <p> 2019.03 ~ 2023.02 </p>
            </Row>

            <Row>
              <p> 2018.03 ~ 2019.02 </p>
            </Row>

          </Col>
          {/* 두 번째 열 (세로 선) */}
          <Col xs={1} className="text-center">
            <div className="vertical-line"></div>
          </Col>
          {/* 세 번째 열 (대학교 졸업) */}
          <Col xs={isSmallScreen ? 6 : 8} className="text-center res-edu-text">
            <Row>
              <p> 숙명여자대학교 공학사, 경영학사 취득 </p> <br></br>
            </Row>
            <Row>
              <p> 숙명여자대학교 소프트웨어융합전공(제 1 전공), 경영학부(복수 전공) 선택 </p> <br></br>
            </Row>
            <Row>
              <p> 숙명여자대학교 기초공학부 (공학대학 자율전공학부) 입학 </p>
            </Row>
          </Col>
        </Row>
        <br></br>

        <h1 className={"resume-card-title"}>Completions</h1> <br></br>
        <Row>
          {/* 첫 번째 열 (연도) */}
          <Col  xs={isSmallScreen ? 4 : 3} className="text-center res-year">

            <Row>
              <p> 2021.06 ~ 2021.07 </p>
            </Row>

            <Row>
              <p> 2021.06 </p>
            </Row>

            <Row>
              <p> 2021.02 ~ 2021.03 </p>
            </Row>

            <Row>
              <p> 2021.09 ~ 2021.12 </p>
            </Row>

            <Row>
              <p> 2021.05 </p>
            </Row>
          </Col>

          {/* 두 번째 열 (세로 선) */}
          <Col xs={1} className="text-center">
            <div className="vertical-line"></div>
          </Col>
          {/* 세 번째 열 (대학교 졸업) */}
          <Col  xs={isSmallScreen ? 6 : 8} className="text-center res-edu-text">
            <Row>
              <p> 한국지능사회정보원 공공데이터 청년인턴 기본역량교육 수료 </p> <br></br>
            </Row>
            <Row>
              <p> 숙명여자대학교 사물인터넷과 AI 장치 개발 프로젝트 비교과 수업 수료 </p> <br></br>
            </Row>
            <Row>
              <p> 코드잇 웹 퍼블리싱 과정 수료 </p>
            </Row>
            <Row>
              <p> 구름 DevelUP 수료 </p>
            </Row>
            <Row>
              <p> AWS Cloud 교육 수료 </p>
            </Row>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default Resume_Education;
